import React from "react";

type Props = {
  className?: string;
};

export const Unavailable = (props: Props) => {
  return (
    <svg
      {...props}
      width={36}
      height={40}
      viewBox="0 0 45 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M44 27V47.75L14.7863 53L1.65649 40.5L1 19.5L30.2137 15L44 27Z"
        fill="#DCA3AE"
      />
      <path
        d="M14.7863 53V31.75M14.7863 53L44 47.75V27M14.7863 53L1.65649 40.5L1 19.5M14.7863 31.75L44 27M14.7863 31.75L1 19.5M44 27L30.2137 15L1 19.5"
        stroke="black"
        strokeWidth={0.656489}
      />
      <path
        d="M1.66667 40.75L15 53V32L1 20L1.66667 40.75Z"
        fill="black"
        fillOpacity={0.3}
      />
      <path
        d="M14.7863 31.9098V53L44 47.7895V27.4436L14.7863 31.9098Z"
        fill="black"
        fillOpacity={0.15}
      />
    </svg>
  );
};
